import React from 'react';
import './features.css';

const Features: React.FC = () => {
  return (
    <section className="section" id="features">
      <div className="container">
        <h2 style={{ margin: '0 0 18px' }}>Why it works</h2>
        <div className="grid features">
          <div className="feature">
            <div className="i">🎛️</div>
            <div><h3>Clean interface</h3><p>Minimal distractions — everything you need to decide, nothing more.</p></div>
          </div>
          <div className="feature">
            <div className="i">💹</div>
            <div><h3>One-click orders</h3><p>Pick direction, amount and time — confirm in a single tap.</p></div>
          </div>
          <div className="feature">
            <div className="i">📈</div>
            <div><h3>Built-in analysis</h3><p>Indicators and timeframes for quick decisions on any device.</p></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
